/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'question': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8.778 5.19A13 13 0 0116 3a13.015 13.015 0 0113 13A13 13 0 118.778 5.19zm6.389 18.557a1.5 1.5 0 101.667-2.495 1.5 1.5 0 00-1.667 2.495zM17 18v-.111a4.5 4.5 0 10-5.5-4.388 1 1 0 002 0A2.5 2.5 0 1116 16a1 1 0 00-1 1v1a1 1 0 002 0z" _fill="#0B2C62"/>'
  }
})
